import type { CaptchaChallenge, LoginRequest, OperatorSession } from '@mall/shared';
import { apiClient } from '../../app/api';

export async function login(payload: LoginRequest): Promise<OperatorSession> {
  return apiClient.post<OperatorSession>('/operator/auth/login', payload);
}

export async function logout(): Promise<void> {
  await apiClient.post<void>('/operator/auth/logout');
}

export async function fetchMe(): Promise<OperatorSession | null> {
  return apiClient.get<OperatorSession | null>('/operator/auth/me');
}

export async function fetchCaptcha(): Promise<CaptchaChallenge> {
  return apiClient.get<CaptchaChallenge>('/operator/auth/captcha');
}

export interface ChangePasswordBody {
  currentPassword: string;
  newPassword: string;
}

export async function changePassword(body: ChangePasswordBody): Promise<void> {
  await apiClient.post<void>('/operator/auth/change-password', body);
}

export interface ChangeSecondPasswordBody {
  currentSecondPassword?: string;
  newSecondPassword: string;
}

export async function changeSecondPassword(body: ChangeSecondPasswordBody): Promise<void> {
  await apiClient.post<void>('/operator/auth/change-second-password', body);
}
